import Vue from 'vue'
import Vuex from 'vuex'
import vendors from './modules/vendors'
import homeowners from './modules/homeowners'
import associations from './modules/association'
import classifications from './modules/classifications'
import acutetoxs from './modules/acutetox'
import ecoinfos from './modules/ecoinfo'
import pointestimate from './modules/pointestimate'
import oecdguidelines from './modules/OECDguidelines'
import hazardcategories from './modules/hazardcategory'
import phrasedisposals from './modules/phrasedisposal'
import phrasepreventions from './modules/phraseprevention'
import phraseresponses from './modules/phraseresponse'
import phrasestorages from './modules/phrasestorage'
import pictogramimages from './modules/pictogramdata'
import elements from './modules/elements'
import classificationgroups from './modules/classificationgroups'
import recipes from './modules/recipes'
import user from './modules/user'
import WordDocs from './modules/WordDocs'
import Customers from './modules/Customers'
import restrictedBlends from './modules/restrictedBlends'


Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        vendors,
        homeowners,
        associations,
        classifications,
        classificationgroups,
        acutetoxs,
        ecoinfos,
        pointestimate,
        oecdguidelines,
        hazardcategories,
        phrasedisposals,
        phrasepreventions,
        phraseresponses,
        phrasestorages,
        pictogramimages,
        elements,
        recipes,
        user,
        WordDocs,
        Customers,
        restrictedBlends
    },
  })